/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DefinitionMetadataMappingInput = {
  sourceMetadataName: string;
  targetMetadataName: string;
};

export type DefinitionPropertyMappingInput = {
  sourcePropertyName: string;
  targetPropertyName?: string | null | undefined;
};

export type EvidenceIdResolverInput = {
  metadata?: JsonQueryInput | null | undefined;
  properties?: JsonQueryInput | null | undefined;
};

export type EvidenceImporterDefinitionInput = {
  dataSourceFilter?: JsonQueryInput | null | undefined;
  evidenceIdResolver?: EvidenceIdResolverInput | null | undefined;
  metadataDefaults?: unknown;
  metadataMappings: Array<DefinitionMetadataMappingInput>;
  propertiesMappings: Array<DefinitionPropertyMappingInput>;
};

export type EvidenceImporterUpsertInput = {
  dataSourceId: string;
  definition: EvidenceImporterDefinitionInput;
  id?: string | null | undefined;
  importProjectId: string;
  name: string;
};

export type JsonQueryInput = {
  array_contains?: unknown;
  equals?: unknown;
  not?: unknown;
  path: Array<string>;
  string_ends_with?: string | null | undefined;
  string_starts_with?: string | null | undefined;
};

export type UpsertEvidenceImporterMutationVariables = Exact<{
  input: Types.EvidenceImporterUpsertInput;
}>;


export type UpsertEvidenceImporterMutation = { cnutUpsertEvidenceImporter:
    | { __typename: 'EvidenceImporterUpsertOutput', id: string }
    | { __typename: 'ValidationError', fields: Array<{ __typename: 'ValidationErrorField', code: string | null, message: string }> }
   };


export const UpsertEvidenceImporterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertEvidenceImporter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvidenceImporterUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpsertEvidenceImporter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EvidenceImporterUpsertOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertEvidenceImporterMutation, UpsertEvidenceImporterMutationVariables>;